import { render, staticRenderFns } from "./category_label.vue?vue&type=template&id=6b4bd5e4&scoped=true&"
import script from "./category_label.vue?vue&type=script&lang=js&"
export * from "./category_label.vue?vue&type=script&lang=js&"
import style0 from "./category_label.vue?vue&type=style&index=0&id=6b4bd5e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4bd5e4",
  null
  
)

export default component.exports